<!--
 * @Description: 钱柜资产详情
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-04-30 15:32:31
 * @LastEditors: situgen@szkingdom.com
-->
<template>
    <div class="bizcomp-money-box">
        <div class="bizcomp-money-box-top">
            <div :class="'money-box-header ' + (interestRate ? 'money-box-header-dynamic' : '')">
                <div
                    :class="
                        'money-box-header-left ' +
                        (interestRate ? 'money-box-header-left-dynamic' : '')
                    "
                >
                    <div class="header-left-content">
                        <div class="money-text">
                            {{ $const.getXJBParam("name") }}
                            <span class="money-text-yuan">(元)</span>
                        </div>
                        <div class="money-num">
                            {{ $util.fmtNum(xjbInfo.marketvalue) }}
                        </div>
                        <div class="money-btn-contain">
                            <div class="money-btn" v-on:click="toCurrencyCharge()">充值</div>
                            <div
                                class="money-btn margin-10"
                                :class="{ 'disabled-btn': !canRedemption }"
                                v-on:click="toCurrencyRedemption()"
                            >
                                取现
                            </div>
                            <div class="money-btn" v-on:click="toAutoAccess()">自动存取</div>
                        </div>
                    </div>
                </div>
                <div class="money-box-header-right">
                    <div
                        :class="
                            'header-right-content ' +
                            (interestRate ? 'header-right-content-dynamic' : '')
                        "
                    >
                        <div
                            :class="
                                'right-content ' + (interestRate ? 'right-content-dynamic' : '')
                            "
                        >
                            <div>
                                <div class="header-text">
                                    {{
                                        xjbInfo.profitdate
                                            ? `${format(xjbInfo.profitdate, "MM-DD")}收益(元)`
                                            : "收益(元)"
                                    }}
                                </div>
                                <div class="header-num">
                                    {{ $util.fmtNum(xjbInfo.lastprofit) }}
                                </div>
                            </div>
                            <div>
                                <div class="header-text">累计收益(元)</div>
                                <div class="header-num">
                                    {{ $util.fmtNum(xjbInfo.currentprofit) }}
                                </div>
                            </div>
                        </div>
                        <div
                            :class="
                                'right-content ' + (interestRate ? 'right-content-dynamic' : '')
                            "
                            style="margin-top: 31px"
                        >
                            <div :class="interestRate ? 'right-content-dynamic' : ''">
                                <div class="header-text">七日年化</div>
                                <div class="header-num">
                                    {{
                                        !xjbInfo.growthrate
                                            ? "--"
                                            : $util.fmtNum(xjbInfo.growthrate, 4) + "%"
                                    }}
                                </div>
                            </div>
                            <div>
                                <div class="header-text">万份收益</div>
                                <div class="header-num">
                                    {{ $util.fmtNum(xjbInfo.fundincomeunit, 4) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="interestRate" class="broadcast-container">
                <div class="broadcast-container-top">
                    <span>七日年化收益率</span>
                    <span class="navdate">({{ format(xjbDetailInfo.navdate, "YYYY-MM-DD") }})</span>
                </div>
                <div class="broadcast-container-bottom">
                    <div
                        class="numericalValue"
                        :class="{
                            'text-red':
                                xjbDetailInfo.growthrate && Number(xjbDetailInfo.growthrate) > 0,
                            'text-green':
                                xjbDetailInfo.growthrate && Number(xjbDetailInfo.growthrate) <= 0
                        }"
                    >
                        {{
                            xjbDetailInfo.growthrate && Number(xjbDetailInfo.growthrate) > 0
                                ? "+"
                                : ""
                        }}{{ xjbDetailInfo.growthrate && xjbDetailInfo.growthrate.toFixed(4) }}%
                    </div>
                    <div class="tips">
                        是活期存款利率的
                        <span>{{ multipleResult }}</span>
                        倍
                    </div>
                </div>
            </div>
        </div>
        <div class="money-box-advance">
            <div class="bar-contain">
                <div class="bar"></div>
                <div class="bar-title">{{ $const.getXJBParam("name") }}优势</div>
            </div>
            <div class="card-contain">
                <div class="card-content">
                    <div class="card-img1">
                        <img src="../../assets/img/advance-1-1.svg" alt="" />
                    </div>
                    <div class="card-text">实时取现</div>
                    <div class="card-img2">
                        <img src="../../assets/img/advance-1-2.svg" alt="" />
                    </div>
                </div>
                <div class="card-content">
                    <div class="card-img1">
                        <img src="../../assets/img/advance-2-1.svg" alt="" />
                    </div>
                    <div class="card-text">0折购基</div>
                    <div class="card-img2">
                        <img src="../../assets/img/advance-2-2.svg" alt="" />
                    </div>
                </div>
                <div class="card-content">
                    <div class="card-img1">
                        <img src="../../assets/img/advance-3-1.svg" alt="" />
                    </div>
                    <div class="card-text">闲钱理财</div>
                    <div class="card-img2">
                        <img src="../../assets/img/advance-3-2.svg" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import fundApi from "@/api/fund";
import format from "date-fns/format";

export default {
    name: "MoneyBox",
    mixins: [mixin],
    data() {
        return {
            format: format,
            xjbInfo: {},
            xjbDetailInfo: {},
            interestRate: "", // 配置的活期存款利率
            multipleResult: "" // 倍数
        };
    },
    computed: {
        canRedemption() {
            // 可用份额大于0时才能取现
            return Number(this.xjbInfo.usableremainshare) > 0;
        }
    },
    mounted() {
        this.getAssetsInfo();
        this.interestRate = this.$cache.getCompanyInfoParam("10111004");
    },
    methods: {
        calculateAndDisplayRatio(growthrate, interestRate) {
            //  * @param {number} growthrate 七日年化收益率
            //  * @param {number} interestRate 活期存款利率
            growthrate = growthrate && Number(growthrate);
            interestRate = interestRate && Number(interestRate);
            try {
                // 检查参数类型，确保是数字
                if (typeof growthrate !== "number" || typeof interestRate !== "number") {
                    throw new Error("参数必须是数字类型");
                }

                // 检查活期存款利率是否为0，避免除以零
                if (interestRate === 0) {
                    throw new Error("活期存款利率不能为零");
                }

                // 计算倍数
                const ratio = growthrate / interestRate;

                // 格式化倍数：保留两位小数
                const formattedRatio = ratio.toFixed(2);
                if (formattedRatio <= 0) {
                    return `--`;
                } else {
                    // 返回结果字符串
                    return `${formattedRatio}`;
                }
            } catch (error) {
                // 捕获错误并返回错误信息
                return `--`;
            }
        },
        toCurrencyCharge() {
            this.$util.fundRiskCheck(this, this.xjbDetailInfo, (res) => {
                if (res) {
                    this.$router.push({ name: "currencycharge" });
                }
            });
        },
        toCurrencyRedemption() {
            // 可用份额为0时不允许取现
            if (!this.canRedemption) {
                return;
            }
            this.$util.fundRiskCheck(this, this.xjbDetailInfo, (res) => {
                if (res) {
                    this.$router.push({ name: "currencyredemption" });
                }
            });
        },
        toAutoAccess() {
            this.$router.push("/autoaccess");
        },
        async getAssetsInfo() {
            try {
                // 优化sessionStorage读取
                const xjbFundInfo = sessionStorage.getItem("xjbFundInfo");
                if (!xjbFundInfo) throw new Error("缺少基金信息");
                this.xjbDetailInfo = JSON.parse(xjbFundInfo);

                // 简化Promise结构
                const { data } = await fundApi.getAssetsList({
                    producttype: "@",
                    sourceflag: "1",
                    fundcode: this.xjbDetailInfo.fundcode
                });

                // 安全访问嵌套数据
                this.xjbInfo = (data && data.returnList && data.returnList[0]) || {};

                // 缓存获取与计算分离
                const companyInfo = this.$cache.getCompanyInfoParam("10111004");
                this.multipleResult = this.calculateAndDisplayRatio(
                    this.xjbDetailInfo.growthrate,
                    companyInfo
                );
            } catch (error) {
                console.error("资产信息获取失败", error);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.bizcomp-money-box {
    margin-bottom: 20px;
    width: 1200px;
    .money-box-header {
        width: 1200px;
        display: flex;
        height: 210px;
        border-radius: 12px;
        background: linear-gradient(260deg, #f2fbff 0%, #ffefec 100%);
        box-sizing: border-box;
        border: 2px solid #f1f1f1;
        .money-box-header-left {
            width: 600px;
            height: 210px;
            padding: 30px 0 44px 70px;
            box-sizing: border-box;
            .header-left-content {
                .money-text {
                    height: 24px;
                    font-size: 16px;
                    font-weight: normal;
                    line-height: 23.4px;
                    color: #333333;
                    .money-text-yuan {
                        height: 14px;
                        font-size: 16px;
                        font-weight: normal;
                        color: #666666;
                        margin-left: 4px;
                    }
                }
                .money-num {
                    margin-top: 20px;
                    height: 28px;
                    font-size: 32px;
                    font-weight: 500;
                    color: #333333;
                }
                .money-btn-contain {
                    display: flex;
                    margin-top: 32px;
                    .money-btn {
                        width: 106px;
                        text-align: center;
                        height: 32px;
                        line-height: 32px;
                        border-radius: 2px;
                        box-sizing: border-box;
                        color: var(--color-primary);
                        border: 1px solid var(--color-primary);
                        cursor: pointer;
                    }
                    .money-btn:hover {
                        background: var(--color-primary);
                        color: #ffffff;
                    }
                    .money-btn.disabled-btn {
                        color: var(--color-text-accent);
                        border-color: var(--color-text-weak);
                        cursor: not-allowed;
                    }
                    .money-btn.disabled-btn:hover {
                        background: transparent;
                        color: var(--color-text-accent);
                        border: 1px solid var(--color-text-weak);
                    }
                }
            }
        }
        .money-box-header-left-dynamic {
            width: 455px;
        }
        .money-box-header-right {
            padding: 30px 0 49px 0;
            .header-right-content {
                padding-left: 70px;
                border-left: 1px solid #eeeeee;
                .right-content {
                    display: flex;
                    > div:first-child {
                        width: 293px;
                    }
                }
                .right-content-dynamic {
                    width: 361px;
                    > div:first-child {
                        width: 193px;
                    }
                }
            }
            .header-right-content-dynamic {
                padding-left: 38px;
            }
        }
    }
    .money-box-header-dynamic {
        width: 860px;
    }
    .bizcomp-money-box-top {
        display: flex;
    }
    .broadcast-container {
        margin-top: -12px;
        margin-left: 19px;
        width: 321px;
        height: 210px;
        background: url("../../assets/img/broadcast-bg.png");
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .broadcast-container-top {
            margin-top: 30px;
            font-size: 14px;
            color: #33383f;
            .navdate {
                margin-left: 5px;
                font-size: 12px;
                color: #a09898;
            }
        }
        .broadcast-container-bottom {
            margin-top: 20px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .numericalValue {
                font-size: 32px;
            }
            .text-red {
                color: #ee2214;
            } /* 正数红色 */
            .text-green {
                color: #00a000;
            } /* 负数绿色 */
            .tips {
                font-size: 12px;
                color: #606266;
                span {
                    color: #ee2214;
                }
            }
        }
    }
    .money-box-advance {
        width: 1200px;
        padding-bottom: 20px;
        background: #ffffff;
        box-sizing: border-box;
        border: 1px solid #f1f1f1;
        margin-top: 20px;
        .bar-contain {
            height: 60px;
            display: flex;
            align-items: center;
            background: #ffffff;
            border: 1px solid #f1f1f1;
            .bar {
                width: 3.71px;
                height: 16px;
                background: var(--color-primary);
                margin: 0 6.5px 0 19px;
            }
            .bar-title {
                font-size: 18px;
                font-weight: 500;
                color: #333333;
            }
        }
        .card-contain {
            display: flex;
            justify-content: space-around;
            margin-top: 20px;
            .card-content {
                width: 380px;
                height: 150px;
                border-radius: 6px;
                background: #f9f9f9;
                display: flex;
                align-items: center;
                .card-img1 {
                    margin-left: 50px;
                }
                .card-text {
                    margin-left: 10.3px;
                    font-size: 16px;
                    font-weight: 500;
                    text-align: center;
                    color: #333333;
                }
                .card-img2 {
                    margin-left: 50px;
                }
            }
        }
    }
    .margin-10 {
        margin: 0 10px;
    }
    .header-text {
        height: 14px;
        font-size: 14px;
        font-weight: normal;
        line-height: 14px;
        color: #666666;
    }
    .header-num {
        margin-top: 8px;
        height: 28px;
        font-family: Source Han Sans CN;
        font-size: 20px;
        font-weight: 500;
        line-height: 28px;
        color: var(--color-primary);
    }
}
</style>
